import { useState } from 'react';

export const PhotoGallery = ({ photos = [], onRemovePhoto, thumbnailSize = '100px' }) => {
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    return (
        <>
            <div className="d-flex flex-wrap gap-2 mb-2">
                {photos.map((photo, index) => (
                    <div key={index} className="position-relative">
                        <img
                            src={photo.thumbPathIncSASToken || photo.pathIncSASToken || photo.thumbPath || photo.path || photo.url}
                            alt={photo.title || photo.name}
                            className="img-thumbnail"
                            style={{ width: thumbnailSize, height: thumbnailSize, objectFit: 'cover', cursor: 'pointer' }}
                            onClick={() => setSelectedPhoto(photo)}
                        />
                        <button
                            className="btn btn-sm btn-danger position-absolute top-0 end-0"
                            style={{ padding: '2px 6px', fontSize: '10px' }}
                            onClick={() => onRemovePhoto(index)}
                        >
                            ✕
                        </button>
                    </div>
                ))}
            </div>

            {selectedPhoto && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setSelectedPhoto(null)}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <div className="modal-header">
                                <h5 className="modal-title">{selectedPhoto.title || selectedPhoto.name}</h5>
                                <button className="btn-close" onClick={() => setSelectedPhoto(null)}></button>
                            </div>
                            <div className="modal-body text-center">
                                <img src={selectedPhoto.pathIncSASToken || selectedPhoto.path || selectedPhoto.url} alt={selectedPhoto.title || selectedPhoto.name} className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};